import React from "react";
import { otherCalculators } from "./ConstantsOtherCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حواسب اخرى";
const DESCRIPTION = "حواسب اخرى";
const KEYWORDS = "حواسب اخرى";
const OG_URL = 'https://do-calculate.com/ar/other-calculators';
function CalculatorsList() {
  return (
    <div className="container rtl-container">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >الحاسبة</th>
            <th >الوصف</th>
          </tr>
        </thead>
        <tbody>
          {otherCalculators.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default CalculatorsList;
